import { getRoot, types } from 'mobx-state-tree';
import ProductPriceInfo from '../ProductPriceInfo';

const CoreProduct = types
  .model('CoreProduct', {
    package_size: types.maybeNull(types.number),
    price_info: types.maybeNull(ProductPriceInfo),
    quantity: types.maybeNull(types.number),
    total_price_info: types.maybeNull(ProductPriceInfo),
  })
  .views((self) => {
    const getTotalPrice = (withTax) => {
      return self.total_price_info?.getPrice(withTax) || null;
    };

    const getRetailPrice = (withTax) => {
      return self.price_info?.getPrice(withTax) || null;
    };

    return {
      /**
       * For legacy code that cannot use getRoot-function, eg. unit tests
       */
      getAnalytics(withTax) {
        const retailPrice = getRetailPrice(withTax);
        const totalPrice = getTotalPrice(withTax);

        return {
          quantity: self.quantity,
          retailPrice,
          totalPrice,
        };
      },
      getQuantityStep() {
        return self.sellInPackage ? self.package_size : 1;
      },
      get analytics() {
        /**
         * This getRoot-function can be used as "private" function when tests and code
         * have been converted to use rootStore and initial data.
         */
        const withTax = true;
        // TODO Below is the original tax logic. It does cause crashes all around so at this point we always use taxes.
        //  NV12 does not support B2B cases yet
        //getRoot(self)?.accountStore.showPricesWithTax || undefined;
        if (!withTax) {
          return;
        }

        const retailPrice = getRetailPrice(withTax);
        const totalPrice = getTotalPrice(withTax);

        return {
          quantity: self.quantity,
          retailPrice,
          totalPrice,
        };
      },
      get sellInPackage() {
        return (
          self.package_size && self.package_size > 0 && self.package_size !== 1
        );
      },
    };
  });

export default CoreProduct;
